import React, { Component } from "react";
import { Modal, Button, Form, Image } from "react-bootstrap";
import IssueSearchSorting from "../issueFilters/IssueSearchSorting";
import SelectIssueSearchSort from "./SelectIssueSearchSort";
import connect from "react-redux/es/connect/connect";
import { withRouter } from "react-router-dom";
import {
  getIssueList,
  clearIssueList,
  getIssueListForAgendaSelect
} from "../../actions/common.action";
import { bindActionCreators } from "redux";
import SelectIssueWithLoader from "./SelectIssueWithLoader";
import {
  getLocalstorage,
  isValidArray,
  transformIssueListPayload
} from "../../helper";
import { get } from "lodash";
import { PROJECT_AWARDED_BY, STATUS } from "../../constant";
import LoadListOnScroll from "../../component/loadListOnScroll";
import { LoaderPage } from "../../component/Loader";
import PermissionHoc from "../PermissionHOC";
import LoaderTemplate from "../../component/LoaderTemplate";
import { FilterLoader } from "../../component/LoadersTemplate";
import FilterComponent from "../FilterComponent";
import IconFilter from "../../assets/filter.svg";
import { ToggleBtn } from "../togglebtn";
import IssueQuickFilter from "../FilterComponent/IssueQuickFilter";
import PragatiIssueQuickFilter from "../FilterComponent/PragatiIssueQuickFilter";
import { getissueListParams } from "../../services/apiServices";
import request from "../../services/requestService";
import TooltipCustom from "./TooltipCustom";
import AgendaStateIssueQF from "../FilterComponent/AgendaStateIssueQF";
const defaultListParams = {
  limit: 50,
  offset: 0,
  sortBy: "CREATED_DATE",
  sortOrder: "DESC",
  agenda: true
};

const sortByArr = [
  {
    sortBy: "PROJECT_COST",
    sortOrder: "DESC",
    name: (
      <span>
        by <b>High</b> budget
      </span>
    ),
    active: "high"
  },
  {
    sortBy: "PROJECT_COST",
    sortOrder: "ASC",
    name: (
      <span>
        by <b>Low</b> budget
      </span>
    ),
    active: "low"
  },
  {
    sortBy: "CREATED_DATE",
    sortOrder: "DESC",
    name: (
      <span>
        by <b>Latest</b> created
      </span>
    ),
    active: "latest"
  },
  {
    sortBy: "CREATED_DATE",
    sortOrder: "ASC",
    name: (
      <span>
        by <b>Old</b> created
      </span>
    ),
    active: "old"
  }
];

export class SelectIssue extends Component {
  // isIssueUncheckedId = null;

  constructor(props) {
    super(props);
    this.state = {
      addInAgendaDisable: props.addInAgendaDisable,
      loadedIssuesListBy: {},
      selectedIssuesOnPage: [],
      filterArrayName: [],
      issueListApiStatus: STATUS.LOADING,
      issuesList: [],
      selectedFilter: {},
      issueListParams: {
        ...defaultListParams,
        projectGroupBy: true,
        sortBy: null,
        sortOrder: null
      },
      offset: 0,
      minRange: 0,
      bubbleFilters: [],
      // projectAwardedByForIssue: getLocalstorage("userSponsoredScheme"),
      projectAwardedByForIssue: this.props.projectAwardedBy,
      projectAwardedBy: false,
      staticfilterdata: [],
      static_payload: {
        offset: 0,
        limit: 1,
        groupCategory: "CENTRAL",
        projectCost: [],
        delayedProject: [],
        costOverRun: [],
        issueAgeing: []
      },
      static_payload1: {
        offset: 0,
        limit: 50,
        groupCategory: "CENTRAL",
        projectCost: [],
        delayedProject: [],
        costOverRun: []
      },
      static_payload50_state: {
        offset: 0,
        limit: 50,
        groupCategory: "STATE",
        isAgendaProjectList: true,
        projectCost: [],
        delayedProject: [],
        costOverRun: []
      },
      quickfilterdatanew: [
        "projectFlags",
        "recipientState",
        "recipientCenter",
        "centerState",
        "stages",
        "category",
        "sponsoringMinistry",
        "projectStatus",
        "projectStage",
        "escalationLevel",
        "issueZones"
      ],
      Monitoringflagcurrent: [],
      ProjectStatuscurrent: [],
      ProjectStagecurrent: [],
      IssueZonecurrent: [],
      RecipientStatecurrent: [],
      RecipientMinistrycurrent: [],
      IssueLocationcurrent: [],
      IssueStagescurrent: [],
      IssueCategorycurrent: [],
      IssueSponsoringMinistrycurrent: [],
      agendaissuestagesdata: true,
      issueAgeing: [],
      delayedProject: [],
      taskCompletionDate: [],
      projectCost: [],
      costOverRun: [],
      QuickFilters: [],
      static_payload_for_state: {
        offset: 0,
        limit: 10,
        groupCategory: "STATE",
        projectCost: [],
        delayedProject: [],
        costOverRun: [],
        issueAgeing: [],
        isAgendaProjectList: true
      },
      staticfilterdata_for_state: [],
      StateQuickFilters: [],
      MonitoringFlag_State: [],
      RecipientDistrict_State: [],
      Recipient_State_Department: [],
      IssueStages_State: [],
      Issue_Category_State: [],
      Issue_Sponsoring_Department: [],
      ProjectStatus_State: [],
      ProjectStage_State: [],
      quickfilterdatastate: [
        "projectFlags",
        "recipientDistrict",
        "recipientStateDepartment",
        "stages",
        "category",
        "sponsoringDepartment",
        "projectStatus",
        "projectStage"
      ]
    };
  }
  handleStateFilterChange = async (updatedFilters, filterName) => {
    if (filterName == undefined) {
      const newData = [];
      newData.push(...updatedFilters);
      this.setState({ StateQuickFilters: newData }, () => {
        //console.log(this.state.QuickFilters)
      });
    } else {
      const updatedData = updatedFilters.map(obj => ({
        ...obj,
        filterName: filterName
      }));
      const newData = [...this.state.StateQuickFilters];
      newData.push(...updatedData);
      this.setState({ StateQuickFilters: newData }, () => {
        //console.log(this.state.QuickFilters);
      });
    }
    const response = await request(
      getissueListParams(
        transformIssueListPayload(this.state.static_payload_for_state)
      )
    );
    this.setState({ staticfilterdata_for_state: response.data.data.filters });
  };
  // handleFilterChange = async (updatedFilters, filterName) => {
  //   if (filterName == undefined) {
  //     const newData = [];
  //     newData.push(...updatedFilters);
  //     this.setState({ bubbleFilters: newData }, () => {
  //       //console.log(this.state.QuickFilters)
  //     });
  //   } else {
  //     const updatedData = updatedFilters.map(obj => ({
  //       ...obj,
  //       filterName: filterName
  //     }));
  //     const newData = [...this.state.bubbleFilters];
  //     newData.push(...updatedData);
  //     this.setState({ bubbleFilters: newData }, () => {
  //       //console.log(this.state.QuickFilters)
  //     });
  //   }
  //   const response = await request(
  //     getissueListParams(transformIssueListPayload(this.state.static_payload))
  //   );
  //   this.setState({ staticfilterdata: response.data.data.filters });
  // };

  //  handleFilterChange = async (updatedFilters, filterName) => {
  //   if (filterName == undefined) {
  //     const newData = [];
  //     newData.push(...updatedFilters);
  //     // console.log(flattenedArray);
  //     this.setState({ bubbleFilters: newData }, () => {
  //       console.log(this.state.bubbleFilters);
  //     });
  //   } else {
  //     const updatedData = updatedFilters.map(obj => ({
  //       ...obj,
  //       filterName: filterName
  //     }));
  //     const newData = [...this.state.bubbleFilters];
  //     newData.push(...updatedData);
  //     this.setState({ bubbleFilters: newData }, () => {
  //       //console.log(this.state.QuickFilters)
  //     });
  //   }
  // };
  handleFilterChange = async updatedFilters => {
    this.setState(() => {
      const uniqueBubbleFilters = Array.from(
        new Map(updatedFilters.map(item => [item.id, item])).values()
      );

      return { bubbleFilters: uniqueBubbleFilters };
    });
  };

  // handleFilterChange = async (updatedFilters, filterName) => {
  //   console.log(updatedFilters);
  //   this.setState(prevState => {
  //     const existing = prevState.bubbleFilters;
  //     if (updatedFilters.length === 0) {
  //       return { bubbleFilters: [] };
  //     } else {
  //       const normalizedFilters = filterName
  //         ? updatedFilters.map(obj => ({ ...obj, filterName }))
  //         : updatedFilters;

  //       const merged = [...existing, ...normalizedFilters];

  //       // Remove duplicates based on `id`
  //       const uniqueFilters = Array.from(
  //         new Map(merged.map(item => [item.id, item])).values()
  //       );
  //       console.log(uniqueFilters);
  //       return { bubbleFilters: uniqueFilters };
  //     }
  //   });
  // };

  componentDidMount = async () => {
    const { selectedProjects } = this.props;
    //console.log(this.props.selectedIssues);
    //Static issue Filter API Call Starts
    const response = await request(
      getissueListParams(transformIssueListPayload(this.state.static_payload))
    );
    this.setState({ staticfilterdata: response.data.data.filters });
    //Static issue Filter API Call End
    const state_response = await request(
      getissueListParams(
        transformIssueListPayload(this.state.static_payload_for_state)
      )
    );
    this.setState({
      staticfilterdata_for_state: state_response.data.data.filters
    });
    this.getIssueListData({
      ...{
        groupCategory: this.getGroupCategory()
      }
    });
  };

  selectionHandler = idx => {
    let { loadedIssuesListBy, selectAll, addInAgendaDisable } = this.state;
    // make single array to loaded list
    let issueList = [];
    Object.keys(loadedIssuesListBy).forEach(key => {
      issueList = [
        ...issueList,
        ...get(loadedIssuesListBy[key], "listDTO", [])
      ];
    });

    /////////////////////////////////////////////////
    if (issueList[idx]) {
      issueList[idx]["isSelected"] = !issueList[idx]["isSelected"];
      if (selectAll) {
        !issueList[idx]["isSelected"] && (selectAll = false);
      }
      this.setState({
        selectAll,
        // addInAgendaDisable: !issueList[idx]["isSelected"],
        loadedIssuesListBy: {
          ...loadedIssuesListBy
        }
      });
    }
    if (this.props.addInAgendaDisable) {
      const checkedIssues = this._getSelectedIssuesOnly();
      //console.log("checkedIssues", checkedIssues);
      if (checkedIssues.length > 0) {
        this.setState({
          addInAgendaDisable: false
        });
      } else {
        this.setState({
          addInAgendaDisable: true
        });
      }
    }
  };

  _getSelectedIssuesOnly = id => {
    const { loadedIssuesListBy } = this.state;
    const currentIssuesList = Object.values(loadedIssuesListBy);
    let activeIssues = [];

    let outerIndex = 0,
      length = isValidArray(currentIssuesList) && currentIssuesList.length;

    for (; outerIndex <= length - 1; outerIndex++) {
      const currentPageIssues = currentIssuesList[outerIndex]["listDTO"];
      for (
        let innerIndex = 0;
        innerIndex <= currentPageIssues.length - 1;
        innerIndex++
      ) {
        const currentIssue = currentPageIssues[innerIndex];
        if (id && currentIssue.isSelected) {
          currentIssue.isSelected = false;
          this.setState(prevState => ({
            loadedIssuesListBy: { ...prevState.loadedIssuesListBy }
          }));
          break;
        } else {
          currentIssue.isSelected && activeIssues.push(currentIssue);
        }
      }
    }
    this.setState({ issueListApiStatus: STATUS.SUCCESS });
    //console.log("activeIssues", activeIssues);
    return activeIssues;
  };

  _getSelectedProjectIssues = id => {
    const { selectedProjects, selectedIssues } = this.props;
    let activeIssues = [];
    //get new selected issue
    const checkedIssues = this._getSelectedIssuesOnly();
    //push old issues and new issues to active issues array
    activeIssues = [...selectedIssues, ...checkedIssues];
    //calculate project-issue array
    let activeProjectsIssues = [];
    //console.log("selectedProjects", selectedProjects, selectedIssues);
    activeProjectsIssues = selectedProjects.map(selectedProject => {
      const updatedProject = { ...selectedProject };
      updatedProject.issuesSelected = activeIssues.filter(
        activeIssue => selectedProject.id === activeIssue.project.id
      );
      return updatedProject;
    });
    //console.log(activeProjectsIssues);

    return activeProjectsIssues;
  };

  // _getSelectedIssues = id => {
  //   const { loadedIssuesListBy } = this.state;
  //   const { selectedProjects, selectedIssues } = this.props;
  //   console.log("selectedProjects", selectedProjects, selectedIssues);
  //   const currentIssuesList = Object.values(loadedIssuesListBy);
  //   let activeIssues = [];
  //   //push old issues to active issues array
  //   activeIssues = [...selectedIssues];
  //   let activeProjectsIssues = [];

  //   let outerIndex = 0,
  //     length = isValidArray(currentIssuesList) && currentIssuesList.length;

  //   for (; outerIndex <= length - 1; outerIndex++) {
  //     const currentPageIssues = currentIssuesList[outerIndex]["listDTO"];
  //     for (
  //       let innerIndex = 0;
  //       innerIndex <= currentPageIssues.length - 1;
  //       innerIndex++
  //     ) {
  //       const currentIssue = currentPageIssues[innerIndex];
  //       if (id && currentIssue.isSelected) {
  //         currentIssue.isSelected = false;
  //         this.setState(prevState => ({
  //           loadedIssuesListBy: { ...prevState.loadedIssuesListBy }
  //         }));
  //         break;
  //       } else {
  //         currentIssue.isSelected && activeIssues.push(currentIssue);
  //       }
  //     }
  //   }
  //   this.setState({ issueListApiStatus: STATUS.SUCCESS });
  //   console.log("activeIssues", activeIssues);

  //   //calculate project-issue array
  //   activeProjectsIssues = selectedProjects.map(selectedProject => {
  //     const updatedProject = { ...selectedProject };
  //     updatedProject.issuesSelected = activeIssues.filter(
  //       activeIssue => selectedProject.id === activeIssue.project.id
  //     );
  //     return updatedProject;
  //   });
  //   console.log(activeProjectsIssues);

  //   return activeProjectsIssues;
  // };

  submitHandler = () => {
    this.setState({ issueListApiStatus: STATUS.LOADING });
    const { submitHandler } = this.props;
    //const getSelected = this._getSelectedIssues();
    //console.log(getSelected);
    //submitHandler(this._getSelectedIssues());
    submitHandler(this._getSelectedProjectIssues());
  };

  loadPageOnScroll = async () => {
    const { isAllDataLoaded } = this.state;
    if (isAllDataLoaded) {
      return;
    }
    this.setState(
      {
        isAllDataLoaded: true
      },
      () => {
        const {
          issueListParams: { offset }
        } = this.state;
        this.getIssueListData({ offset: offset + 1 });
      }
    );
  };

  toggleSelectAll = () => {
    const { selectAll, loadedIssuesListBy } = this.state;
    Object.keys(loadedIssuesListBy).forEach(key => {
      isValidArray(
        loadedIssuesListBy[key] && loadedIssuesListBy[key]["listDTO"]
      ) &&
        loadedIssuesListBy[key]["listDTO"].forEach(issue => {
          issue.isSelected = !selectAll;
        });
    });
    this.setState({
      selectAll: !selectAll
    });

    if (this.props.addInAgendaDisable) {
      const checkedIssues = this._getSelectedIssuesOnly();
      //console.log("checkedIssues", checkedIssues);
      if (checkedIssues.length > 0) {
        this.setState({
          addInAgendaDisable: false
        });
      } else {
        this.setState({
          addInAgendaDisable: true
        });
      }
    }
  };

  getIssueListData = (params = {}) => {
    try {
      const { selectedIssues, selectedProjects } = this.props;
      //console.log("selectedIssues", this.props.selectedIssues);
      const {
        issueListParams,
        loadedIssuesListBy,
        issueAgeing,
        delayedProject,
        taskCompletionDate,
        projectCost,
        costOverRun
      } = this.state;
      const selectedProjectIds = selectedProjects.map(item => item.id);
      let selectedIssuesIdArr =
        (selectedIssues &&
          selectedIssues.length &&
          selectedIssues.map(item => item.id)) ||
        [];
      const currentParams = {
        ...issueListParams,
        ...params,
        selectedIssuesIdArr,
        selectedProjectIds,
        issueAgeing,
        delayedProject,
        taskCompletionDate,
        projectCost,
        costOverRun
      };
      console.log("currentParams", currentParams);
      if (!currentParams.search) {
        delete currentParams.search;
      }
      if (currentParams.projectGroupBy) {
        delete currentParams.sortOrder;
        delete currentParams.sortBy;
      }
      if (
        currentParams.recipientCenter &&
        !currentParams.recipientCenter.length
      ) {
        delete currentParams.recipientCenter;
      }
      if (
        currentParams.recipientState &&
        !currentParams.recipientState.length
      ) {
        delete currentParams.recipientState;
      }
      if (!currentParams.recipientCenter && !currentParams.recipientState) {
        delete currentParams.issueDistStateDept;
      }
      this.setState(
        {
          issueListApiStatus: STATUS.LOADING,
          issueListParams: currentParams
        },
        async () => {
          const response = await getIssueListForAgendaSelect(
            undefined,
            currentParams
          );
          if (response) {
            const { status, data } = response;
            if (status) {
              this.setState({
                loadedIssuesListBy: {
                  ...loadedIssuesListBy,
                  [currentParams.offset]: data
                },
                issueListApiStatus: STATUS.SUCCESS,
                isAllDataLoaded: !isValidArray(get(response, "data.listDTO"))
              });
            } else {
              this.setState({
                issueListApiStatus: STATUS.ERROR,
                isAllDataLoaded: !isValidArray(get(response, "data.listDTO"))
              });
            }
          }
        }
      );
    } catch (e) {
      console.log("Error while fetching error", e);
    }
  };

  handleChange = event => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  // handleCheckbox = (filter, filterName) => {
  //   const filterData = this.postFilterData(filter, filterName);
  //   this.getIssueListData(filterData);
  // };

  // removeFilter = filter => {
  //   const params = this.postFilterData(filter, filter.filterName);
  //   this.getIssueListData(params);
  // };

  // show applied filters
  isFiltersAlreadyApplied = (filterArr, filter) => {
    let currentIndex = 0;
    const filterApplied = filterArr.find((value, index) => {
      currentIndex = index;
      return value.displayName === filter.displayName;
    });
    return { filter: filterApplied, index: currentIndex };
  };

  postFilterData = (value, filterName) => {
    // console.log(value)
    //console.log(filterName)
    if (value.checked) {
      const newValue1 = { ...value, filterName: filterName };
      const newItems1 = [...this.state.bubbleFilters];
      newItems1.push(newValue1);
      this.setState({ bubbleFilters: newItems1 }, () => {
        //console.log(this.state.bubbleFilters)
      });
    } else {
      const targetObjectIndex = this.state.bubbleFilters.findIndex(
        item => item.displayName === value.displayName
      );

      if (targetObjectIndex !== -1) {
        this.state.bubbleFilters.splice(targetObjectIndex, 1);
      }
    }
    if (value.hasOwnProperty("filterName")) {
      const entries = Object.entries(value);
      const lastEntry = entries.pop();
      delete value[lastEntry[0]];
      //console.log(value)
    }
    let { issueListParams, filterArrayName } = this.state;
    let currentFilter = issueListParams[filterName];

    const filter = this.isFiltersAlreadyApplied(filterArrayName, value);
    this.setState({
      loadedIssuesListBy: {}
    });

    // to keep issueListParams seperate we are rendering filterArray name here
    if (filterName !== "projectIdFilter") {
      let newArr = [];
      if (!get(filter, "filter.displayName")) {
        newArr = [{ ...value, filterName }];
      } else {
        value.checked = false;
        filterArrayName.splice(get(filter, "index"), 1);
      }
      this.setState({
        filterArrayName: [...filterArrayName, ...newArr]
      });
    }
    switch (filterName) {
      // in this case value is object
      case "stages":
      case "category":
      case "subCategory":
      case "projectStatus":
      case "recipientState":
      case "recipientDistrict":
      case "recipientCenter":
      case "sponsoringState":
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "districtStateDept":
      case "recipientDistrictStateDept":
      case "assignedToDistrictStateDept":
      case "projectStage":
      case "recipientStateDepartment":
      case "issueDistStateDept":
      case "proponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "centerState":
      case "projectFlags":
      case "escalationLevel":
      case "issueZones":
        currentFilter = currentFilter || [];
        let filter = currentFilter.find(val => val === value.key);
        !filter
          ? currentFilter.push(value.key)
          : (currentFilter = currentFilter.filter(val => val !== value.key));
        issueListParams = {
          ...issueListParams,
          [filterName]: currentFilter
        };
        //console.log(issueListParams)
        break;

      // currentFilter = currentFilter || [];
      // const val = currentFilter.indexOf(+value.key) === -1;
      // val
      //   ? currentFilter.push(+value.key)
      //   : currentFilter.splice(currentFilter.indexOf(+value.key), 1);
      // issueListParams = {
      //   ...issueListParams,
      //   [filterName]: currentFilter,
      // };
      // break;

      // in this case value is string
      case "projectIdFilter":
        currentFilter = value || null;
        !currentFilter && delete issueListParams[filterName];
        issueListParams = value
          ? {
              ...issueListParams,
              sortBy: null,
              sortOrder: null,
              [filterName]: currentFilter
            }
          : { ...issueListParams, ...defaultListParams };
        break;

      case "mom":
        currentFilter = value.checked;
        !currentFilter && delete issueListParams[value.key];
        issueListParams = !currentFilter
          ? { ...issueListParams, ...defaultListParams }
          : { ...issueListParams, [value.key]: currentFilter };
        break;

      case "createdByMinistry":
        currentFilter = value.checked ? +value.key : null;
        !currentFilter && delete issueListParams[filterName];
        issueListParams = !currentFilter
          ? { ...issueListParams }
          : { ...issueListParams, [filterName]: currentFilter };
        break;

      // In this case value is boolean
      case "pmg":
      case "pragatiReview":
        currentFilter = value.checked;
        !currentFilter && delete issueListParams[filterName];
        issueListParams = !currentFilter
          ? { ...issueListParams, ...defaultListParams }
          : { ...issueListParams, [filterName]: currentFilter };
        break;

      case "projectGroupBy":
        currentFilter = value.checked;
        !currentFilter && delete issueListParams[filterName];
        issueListParams = !currentFilter
          ? { ...issueListParams, ...defaultListParams }
          : {
              ...issueListParams,
              [filterName]: currentFilter,
              sortOrder: null,
              sortBy: null
            };
        break;
      case "issueAgeing":
        if (value.checked) {
          currentFilter = currentFilter || [];
          const { key } = value || {};
          const [fromStr, toStr] = (key || "").split("-");
          const from = fromStr === "null" ? null : fromStr;
          const to = toStr === "null" ? null : toStr;

          this.setState(
            prevState => ({
              issueAgeing: [
                ...prevState.issueAgeing,
                {
                  from: from,
                  to: to
                }
              ]
            }),
            () => {
              //console.log(this.state.issueAgeing);
              const updatedCurrentFilter = this.state.issueAgeing;

              this.setState(prevState => {
                const updatedIssueListParams =
                  updatedCurrentFilter.length === 0
                    ? { ...prevState.issueListParams }
                    : {
                        ...prevState.issueListParams,
                        [filterName]: updatedCurrentFilter
                      };
                //console.log(updatedIssueListParams);
                this.setState({ issueAgeingFilter: updatedIssueListParams });
                return { issueListParams: updatedIssueListParams };
              });
            }
          );
        } else {
          //console.log(value)
          const { key } = value || {};
          const [fromStr, toStr] = (key || "").split("-");
          const from = fromStr === "null" ? null : fromStr;
          const to = toStr === "null" ? null : toStr;
          const data = {
            from: from,
            to: to
          };
          const updatedArray = this.state.issueAgeing.filter(item => {
            return !(item.from === data.from && item.to === data.to);
          });
          //console.log(updatedArray)
          this.setState({ issueAgeing: updatedArray });
        }
        break;
      case "delayedProject":
        if (value.checked) {
          currentFilter = currentFilter || [];
          const { key } = value || {};
          const [fromStr, toStr] = (key || "").split("-");
          const from = fromStr === "null" ? null : fromStr;
          const to = toStr === "null" ? null : toStr;

          this.setState(
            prevState => ({
              delayedProject: [
                ...prevState.delayedProject,
                {
                  from: from,
                  to: to
                }
              ]
            }),
            () => {
              const updatedCurrentFilter = this.state.delayedProject;

              this.setState(prevState => {
                const updatedIssueListParams =
                  updatedCurrentFilter.length === 0
                    ? { ...prevState.issueListParams }
                    : {
                        ...prevState.issueListParams,
                        [filterName]: updatedCurrentFilter
                      };
                return { issueListParams: updatedIssueListParams };
              });
            }
          );
        } else {
          const { key } = value || {};
          const [fromStr, toStr] = (key || "").split("-");
          const from = fromStr === "null" ? null : fromStr;
          const to = toStr === "null" ? null : toStr;
          const data = {
            from: from,
            to: to
          };
          const updatedArray = this.state.delayedProject.filter(item => {
            return !(item.from === data.from && item.to === data.to);
          });
          this.setState({ delayedProject: updatedArray });
        }
        break;
      case "taskCompletionDate":
        if (value.checked) {
          currentFilter = currentFilter || [];
          const { key } = value || {};
          const [fromStr, toStr] = (key || "").split("-");
          const from = fromStr === "null" ? null : fromStr;
          const to = toStr === "null" ? null : toStr;

          this.setState(
            prevState => ({
              taskCompletionDate: [
                ...prevState.taskCompletionDate,
                {
                  from: from,
                  to: to
                }
              ]
            }),
            () => {
              const updatedCurrentFilter = this.state.taskCompletionDate;

              this.setState(prevState => {
                const updatedIssueListParams =
                  updatedCurrentFilter.length === 0
                    ? { ...prevState.issueListParams }
                    : {
                        ...prevState.issueListParams,
                        [filterName]: updatedCurrentFilter
                      };
                return { issueListParams: updatedIssueListParams };
              });
            }
          );
        } else {
          const { key } = value || {};
          const [fromStr, toStr] = (key || "").split("-");
          const from = fromStr === "null" ? null : fromStr;
          const to = toStr === "null" ? null : toStr;
          const data = {
            from: from,
            to: to
          };
          const updatedArray = this.state.taskCompletionDate.filter(item => {
            return !(item.from === data.from && item.to === data.to);
          });
          this.setState({ taskCompletionDate: updatedArray });
        }
        break;
      case "projectCost":
        if (value.checked) {
          currentFilter = currentFilter || [];
          const { key } = value || {};
          const [fromStr, toStr] = (key || "").split("-");
          const from = fromStr === "null" ? null : fromStr;
          const to = toStr === "null" ? null : toStr;

          this.setState(
            prevState => ({
              projectCost: [
                ...prevState.projectCost,
                {
                  from: from,
                  to: to
                }
              ]
            }),
            () => {
              const updatedCurrentFilter = this.state.projectCost;

              this.setState(prevState => {
                const updatedIssueListParams =
                  updatedCurrentFilter.length === 0
                    ? { ...prevState.issueListParams }
                    : {
                        ...prevState.issueListParams,
                        [filterName]: updatedCurrentFilter
                      };
                return { issueListParams: updatedIssueListParams };
              });
            }
          );
        } else {
          const { key } = value || {};
          const [fromStr, toStr] = (key || "").split("-");
          const from = fromStr === "null" ? null : fromStr;
          const to = toStr === "null" ? null : toStr;
          const data = {
            from: from,
            to: to
          };
          const updatedArray = this.state.projectCost.filter(item => {
            return !(item.from === data.from && item.to === data.to);
          });
          this.setState({ projectCost: updatedArray });
        }
        break;

      case "costOverRun":
        if (value.checked) {
          currentFilter = currentFilter || [];
          const { key } = value || {};
          const [fromStr, toStr] = (key || "").split("-");
          const from = fromStr === "null" ? null : fromStr;
          const to = toStr === "null" ? null : toStr;

          this.setState(
            prevState => ({
              costOverRun: [
                ...prevState.costOverRun,
                {
                  from: from,
                  to: to
                }
              ]
            }),
            () => {
              const updatedCurrentFilter = this.state.costOverRun;

              this.setState(prevState => {
                const updatedIssueListParams =
                  updatedCurrentFilter.length === 0
                    ? { ...prevState.issueListParams }
                    : {
                        ...prevState.issueListParams,
                        [filterName]: updatedCurrentFilter
                      };
                return { issueListParams: updatedIssueListParams };
              });
            }
          );
        } else {
          const { key } = value || {};
          const [fromStr, toStr] = (key || "").split("-");
          const from = fromStr === "null" ? null : fromStr;
          const to = toStr === "null" ? null : toStr;
          const data = {
            from: from,
            to: to
          };
          const updatedArray = this.state.costOverRun.filter(item => {
            return !(item.from === data.from && item.to === data.to);
          });
          this.setState({ costOverRun: updatedArray });
        }
        break;

      default:
        break;
    }
    return { ...issueListParams, offset: 0 };
  };
  postFilterData1 = value => {
    const projectFlagskey = value.map(item => item.key);
    this.setState({ Monitoringflagcurrent: projectFlagskey }, () => {
      this.getIssueListData({
        ...this.state.static_payload1,
        [this.state.quickfilterdatanew[0]]: this.state.Monitoringflagcurrent,
        [this.state.quickfilterdatanew[1]]: this.state.RecipientStatecurrent,
        [this.state.quickfilterdatanew[2]]: this.state.RecipientMinistrycurrent,
        [this.state.quickfilterdatanew[3]]: this.state.IssueLocationcurrent,
        [this.state.quickfilterdatanew[4]]: this.state.IssueStagescurrent,
        [this.state.quickfilterdatanew[5]]: this.state.IssueCategorycurrent,
        [this.state.quickfilterdatanew[6]]: this.state
          .IssueSponsoringMinistrycurrent,
        [this.state.quickfilterdatanew[7]]: this.state.ProjectStatuscurrent,
        [this.state.quickfilterdatanew[8]]: this.state.ProjectStagecurrent,
        [this.state.quickfilterdatanew[10]]: this.state.IssueZonecurrent
      });
    });
  };
  postFilterData1_State = value => {
    const projectFlagskey = value.map(item => item.key);
    this.setState({ MonitoringFlag_State: projectFlagskey }, () => {
      this.getIssueListData({
        ...this.state.static_payload50_state,
        [this.state.quickfilterdatastate[0]]: this.state.MonitoringFlag_State,
        [this.state.quickfilterdatastate[1]]: this.state
          .RecipientDistrict_State,
        [this.state.quickfilterdatastate[2]]: this.state
          .Recipient_State_Department,
        [this.state.quickfilterdatastate[3]]: this.state.IssueStages_State,
        [this.state.quickfilterdatastate[4]]: this.state.Issue_Category_State,
        [this.state.quickfilterdatastate[5]]: this.state
          .Issue_Sponsoring_Department,
        [this.state.quickfilterdatastate[6]]: this.state.ProjectStatus_State,
        [this.state.quickfilterdatastate[7]]: this.state.ProjectStage_State
      });
    });
  };
  postFilterData2_State = value => {
    const projectFlagskey = value.map(item => item.key);
    this.setState({ RecipientDistrict_State: projectFlagskey }, () => {
      this.getIssueListData({
        ...this.state.static_payload50_state,
        [this.state.quickfilterdatastate[0]]: this.state.MonitoringFlag_State,
        [this.state.quickfilterdatastate[1]]: this.state
          .RecipientDistrict_State,
        [this.state.quickfilterdatastate[2]]: this.state
          .Recipient_State_Department,
        [this.state.quickfilterdatastate[3]]: this.state.IssueStages_State,
        [this.state.quickfilterdatastate[4]]: this.state.Issue_Category_State,
        [this.state.quickfilterdatastate[5]]: this.state
          .Issue_Sponsoring_Department,
        [this.state.quickfilterdatastate[6]]: this.state.ProjectStatus_State,
        [this.state.quickfilterdatastate[7]]: this.state.ProjectStage_State
      });
    });
  };
  postFilterData3_State = value => {
    const projectFlagskey = value.map(item => item.key);
    this.setState({ Recipient_State_Department: projectFlagskey }, () => {
      this.getIssueListData({
        ...this.state.static_payload50_state,
        [this.state.quickfilterdatastate[0]]: this.state.MonitoringFlag_State,
        [this.state.quickfilterdatastate[1]]: this.state
          .RecipientDistrict_State,
        [this.state.quickfilterdatastate[2]]: this.state
          .Recipient_State_Department,
        [this.state.quickfilterdatastate[3]]: this.state.IssueStages_State,
        [this.state.quickfilterdatastate[4]]: this.state.Issue_Category_State,
        [this.state.quickfilterdatastate[5]]: this.state
          .Issue_Sponsoring_Department,
        [this.state.quickfilterdatastate[6]]: this.state.ProjectStatus_State,
        [this.state.quickfilterdatastate[7]]: this.state.ProjectStage_State
      });
    });
  };
  postFilterData4_State = value => {
    const projectFlagskey = value.map(item => item.key);
    this.setState({ IssueStages_State: projectFlagskey }, () => {
      this.getIssueListData({
        ...this.state.static_payload50_state,
        [this.state.quickfilterdatastate[0]]: this.state.MonitoringFlag_State,
        [this.state.quickfilterdatastate[1]]: this.state
          .RecipientDistrict_State,
        [this.state.quickfilterdatastate[2]]: this.state
          .Recipient_State_Department,
        [this.state.quickfilterdatastate[3]]: this.state.IssueStages_State,
        [this.state.quickfilterdatastate[4]]: this.state.Issue_Category_State,
        [this.state.quickfilterdatastate[5]]: this.state
          .Issue_Sponsoring_Department,
        [this.state.quickfilterdatastate[6]]: this.state.ProjectStatus_State,
        [this.state.quickfilterdatastate[7]]: this.state.ProjectStage_State
      });
    });
  };
  postFilterData5_State = value => {
    const projectFlagskey = value.map(item => item.key);
    this.setState({ Issue_Category_State: projectFlagskey }, () => {
      this.getIssueListData({
        ...this.state.static_payload50_state,
        [this.state.quickfilterdatastate[0]]: this.state.MonitoringFlag_State,
        [this.state.quickfilterdatastate[1]]: this.state
          .RecipientDistrict_State,
        [this.state.quickfilterdatastate[2]]: this.state
          .Recipient_State_Department,
        [this.state.quickfilterdatastate[3]]: this.state.IssueStages_State,
        [this.state.quickfilterdatastate[4]]: this.state.Issue_Category_State,
        [this.state.quickfilterdatastate[5]]: this.state
          .Issue_Sponsoring_Department,
        [this.state.quickfilterdatastate[6]]: this.state.ProjectStatus_State,
        [this.state.quickfilterdatastate[7]]: this.state.ProjectStage_State
      });
    });
  };
  postFilterData6_State = value => {
    const projectFlagskey = value.map(item => item.key);
    this.setState({ Issue_Sponsoring_Department: projectFlagskey }, () => {
      this.getIssueListData({
        ...this.state.static_payload50_state,
        [this.state.quickfilterdatastate[0]]: this.state.MonitoringFlag_State,
        [this.state.quickfilterdatastate[1]]: this.state
          .RecipientDistrict_State,
        [this.state.quickfilterdatastate[2]]: this.state
          .Recipient_State_Department,
        [this.state.quickfilterdatastate[3]]: this.state.IssueStages_State,
        [this.state.quickfilterdatastate[4]]: this.state.Issue_Category_State,
        [this.state.quickfilterdatastate[5]]: this.state
          .Issue_Sponsoring_Department,
        [this.state.quickfilterdatastate[6]]: this.state.ProjectStatus_State,
        [this.state.quickfilterdatastate[7]]: this.state.ProjectStage_State
      });
    });
  };
  postFilterData7_State = value => {
    const projectFlagskey = value.map(item => item.key);
    this.setState({ ProjectStatus_State: projectFlagskey }, () => {
      this.getIssueListData({
        ...this.state.static_payload50_state,
        [this.state.quickfilterdatastate[0]]: this.state.MonitoringFlag_State,
        [this.state.quickfilterdatastate[1]]: this.state
          .RecipientDistrict_State,
        [this.state.quickfilterdatastate[2]]: this.state
          .Recipient_State_Department,
        [this.state.quickfilterdatastate[3]]: this.state.IssueStages_State,
        [this.state.quickfilterdatastate[4]]: this.state.Issue_Category_State,
        [this.state.quickfilterdatastate[5]]: this.state
          .Issue_Sponsoring_Department,
        [this.state.quickfilterdatastate[6]]: this.state.ProjectStatus_State,
        [this.state.quickfilterdatastate[7]]: this.state.ProjectStage_State
      });
    });
  };
  postFilterData8_State = value => {
    const projectFlagskey = value.map(item => item.key);
    this.setState({ ProjectStage_State: projectFlagskey }, () => {
      this.getIssueListData({
        ...this.state.static_payload50_state,
        [this.state.quickfilterdatastate[0]]: this.state.MonitoringFlag_State,
        [this.state.quickfilterdatastate[1]]: this.state
          .RecipientDistrict_State,
        [this.state.quickfilterdatastate[2]]: this.state
          .Recipient_State_Department,
        [this.state.quickfilterdatastate[3]]: this.state.IssueStages_State,
        [this.state.quickfilterdatastate[4]]: this.state.Issue_Category_State,
        [this.state.quickfilterdatastate[5]]: this.state
          .Issue_Sponsoring_Department,
        [this.state.quickfilterdatastate[6]]: this.state.ProjectStatus_State,
        [this.state.quickfilterdatastate[7]]: this.state.ProjectStage_State
      });
    });
  };
  postFilterData2 = value => {
    const recipientStatekey = value.map(item => item.key);
    this.setState({ RecipientStatecurrent: recipientStatekey }, () => {
      this.getIssueListData({
        ...this.state.static_payload1,
        [this.state.quickfilterdatanew[0]]: this.state.Monitoringflagcurrent,
        [this.state.quickfilterdatanew[1]]: this.state.RecipientStatecurrent,
        [this.state.quickfilterdatanew[2]]: this.state.RecipientMinistrycurrent,
        [this.state.quickfilterdatanew[3]]: this.state.IssueLocationcurrent,
        [this.state.quickfilterdatanew[4]]: this.state.IssueStagescurrent,
        [this.state.quickfilterdatanew[5]]: this.state.IssueCategorycurrent,
        [this.state.quickfilterdatanew[6]]: this.state
          .IssueSponsoringMinistrycurrent,
        [this.state.quickfilterdatanew[7]]: this.state.ProjectStatuscurrent,
        [this.state.quickfilterdatanew[8]]: this.state.ProjectStagecurrent,
        [this.state.quickfilterdatanew[10]]: this.state.IssueZonecurrent
      });
    });
  };
  postFilterData3 = value => {
    const recipientMinistrykey = value.map(item => item.key);
    this.setState({ RecipientMinistrycurrent: recipientMinistrykey }, () => {
      this.getIssueListData({
        ...this.state.static_payload1,
        [this.state.quickfilterdatanew[0]]: this.state.Monitoringflagcurrent,
        [this.state.quickfilterdatanew[1]]: this.state.RecipientStatecurrent,
        [this.state.quickfilterdatanew[2]]: this.state.RecipientMinistrycurrent,
        [this.state.quickfilterdatanew[3]]: this.state.IssueLocationcurrent,
        [this.state.quickfilterdatanew[4]]: this.state.IssueStagescurrent,
        [this.state.quickfilterdatanew[5]]: this.state.IssueCategorycurrent,
        [this.state.quickfilterdatanew[6]]: this.state
          .IssueSponsoringMinistrycurrent,
        [this.state.quickfilterdatanew[7]]: this.state.ProjectStatuscurrent,
        [this.state.quickfilterdatanew[8]]: this.state.ProjectStagecurrent,
        [this.state.quickfilterdatanew[10]]: this.state.IssueZonecurrent
      });
    });
  };
  postFilterData4 = value => {
    const issueLocationkey = value.map(item => item.key);
    this.setState({ IssueLocationcurrent: issueLocationkey }, () => {
      this.getIssueListData({
        ...this.state.static_payload1,
        [this.state.quickfilterdatanew[0]]: this.state.Monitoringflagcurrent,
        [this.state.quickfilterdatanew[1]]: this.state.RecipientStatecurrent,
        [this.state.quickfilterdatanew[2]]: this.state.RecipientMinistrycurrent,
        [this.state.quickfilterdatanew[3]]: this.state.IssueLocationcurrent,
        [this.state.quickfilterdatanew[4]]: this.state.IssueStagescurrent,
        [this.state.quickfilterdatanew[5]]: this.state.IssueCategorycurrent,
        [this.state.quickfilterdatanew[6]]: this.state
          .IssueSponsoringMinistrycurrent,
        [this.state.quickfilterdatanew[7]]: this.state.ProjectStatuscurrent,
        [this.state.quickfilterdatanew[8]]: this.state.ProjectStagecurrent,
        [this.state.quickfilterdatanew[10]]: this.state.IssueZonecurrent
      });
    });
  };
  postFilterData5 = value => {
    const issueStageskey = value.map(item => item.key);
    this.setState({ IssueStagescurrent: issueStageskey }, () => {
      this.getIssueListData({
        ...this.state.static_payload1,
        [this.state.quickfilterdatanew[0]]: this.state.Monitoringflagcurrent,
        [this.state.quickfilterdatanew[1]]: this.state.RecipientStatecurrent,
        [this.state.quickfilterdatanew[2]]: this.state.RecipientMinistrycurrent,
        [this.state.quickfilterdatanew[3]]: this.state.IssueLocationcurrent,
        [this.state.quickfilterdatanew[4]]: this.state.IssueStagescurrent,
        [this.state.quickfilterdatanew[5]]: this.state.IssueCategorycurrent,
        [this.state.quickfilterdatanew[6]]: this.state
          .IssueSponsoringMinistrycurrent,
        [this.state.quickfilterdatanew[7]]: this.state.ProjectStatuscurrent,
        [this.state.quickfilterdatanew[8]]: this.state.ProjectStagecurrent,
        [this.state.quickfilterdatanew[10]]: this.state.IssueZonecurrent
      });
    });
  };
  postFilterData6 = value => {
    const issueCategorykey = value.map(item => item.key);
    this.setState({ IssueCategorycurrent: issueCategorykey }, () => {
      this.getIssueListData({
        ...this.state.static_payload1,
        [this.state.quickfilterdatanew[0]]: this.state.Monitoringflagcurrent,
        [this.state.quickfilterdatanew[1]]: this.state.RecipientStatecurrent,
        [this.state.quickfilterdatanew[2]]: this.state.RecipientMinistrycurrent,
        [this.state.quickfilterdatanew[3]]: this.state.IssueLocationcurrent,
        [this.state.quickfilterdatanew[4]]: this.state.IssueStagescurrent,
        [this.state.quickfilterdatanew[5]]: this.state.IssueCategorycurrent,
        [this.state.quickfilterdatanew[6]]: this.state
          .IssueSponsoringMinistrycurrent,
        [this.state.quickfilterdatanew[7]]: this.state.ProjectStatuscurrent,
        [this.state.quickfilterdatanew[8]]: this.state.ProjectStagecurrent,
        [this.state.quickfilterdatanew[10]]: this.state.IssueZonecurrent
      });
    });
  };
  postFilterData7 = value => {
    const issueSponsoringMinistrykey = value.map(item => item.key);
    this.setState(
      { IssueSponsoringMinistrycurrent: issueSponsoringMinistrykey },
      () => {
        this.getIssueListData({
          ...this.state.static_payload1,
          [this.state.quickfilterdatanew[0]]: this.state.Monitoringflagcurrent,
          [this.state.quickfilterdatanew[1]]: this.state.RecipientStatecurrent,
          [this.state.quickfilterdatanew[2]]: this.state
            .RecipientMinistrycurrent,
          [this.state.quickfilterdatanew[3]]: this.state.IssueLocationcurrent,
          [this.state.quickfilterdatanew[4]]: this.state.IssueStagescurrent,
          [this.state.quickfilterdatanew[5]]: this.state.IssueCategorycurrent,
          [this.state.quickfilterdatanew[6]]: this.state
            .IssueSponsoringMinistrycurrent,
          [this.state.quickfilterdatanew[7]]: this.state.ProjectStatuscurrent,
          [this.state.quickfilterdatanew[8]]: this.state.ProjectStagecurrent,
          [this.state.quickfilterdatanew[10]]: this.state.IssueZonecurrent
        });
      }
    );
  };
  postFilterData8 = value => {
    const projectStatuskey = value.map(item => item.key);
    this.setState({ ProjectStatuscurrent: projectStatuskey }, () => {
      this.getIssueListData({
        ...this.state.static_payload1,
        [this.state.quickfilterdatanew[0]]: this.state.Monitoringflagcurrent,
        [this.state.quickfilterdatanew[1]]: this.state.RecipientStatecurrent,
        [this.state.quickfilterdatanew[2]]: this.state.RecipientMinistrycurrent,
        [this.state.quickfilterdatanew[3]]: this.state.IssueLocationcurrent,
        [this.state.quickfilterdatanew[4]]: this.state.IssueStagescurrent,
        [this.state.quickfilterdatanew[5]]: this.state.IssueCategorycurrent,
        [this.state.quickfilterdatanew[6]]: this.state
          .IssueSponsoringMinistrycurrent,
        [this.state.quickfilterdatanew[7]]: this.state.ProjectStatuscurrent,
        [this.state.quickfilterdatanew[8]]: this.state.ProjectStagecurrent,
        [this.state.quickfilterdatanew[10]]: this.state.IssueZonecurrent
      });
    });
  };
  postFilterData9 = value => {
    const projectStageskey = value.map(item => item.key);
    this.setState({ ProjectStagecurrent: projectStageskey }, () => {
      this.getIssueListData({
        ...this.state.static_payload1,
        [this.state.quickfilterdatanew[0]]: this.state.Monitoringflagcurrent,
        [this.state.quickfilterdatanew[1]]: this.state.RecipientStatecurrent,
        [this.state.quickfilterdatanew[2]]: this.state.RecipientMinistrycurrent,
        [this.state.quickfilterdatanew[3]]: this.state.IssueLocationcurrent,
        [this.state.quickfilterdatanew[4]]: this.state.IssueStagescurrent,
        [this.state.quickfilterdatanew[5]]: this.state.IssueCategorycurrent,
        [this.state.quickfilterdatanew[6]]: this.state
          .IssueSponsoringMinistrycurrent,
        [this.state.quickfilterdatanew[7]]: this.state.ProjectStatuscurrent,
        [this.state.quickfilterdatanew[8]]: this.state.ProjectStagecurrent,
        [this.state.quickfilterdatanew[10]]: this.state.IssueZonecurrent
      });
    });
  };
  postFilterData10 = value => {
    //console.log(value);
    const issuesZonekey = value.map(item => item.key);
    this.setState({ IssueZonecurrent: issuesZonekey }, () => {
      this.getIssueListData({
        ...this.state.static_payload1,
        [this.state.quickfilterdatanew[0]]: this.state.Monitoringflagcurrent,
        [this.state.quickfilterdatanew[1]]: this.state.RecipientStatecurrent,
        [this.state.quickfilterdatanew[2]]: this.state.RecipientMinistrycurrent,
        [this.state.quickfilterdatanew[3]]: this.state.IssueLocationcurrent,
        [this.state.quickfilterdatanew[4]]: this.state.IssueStagescurrent,
        [this.state.quickfilterdatanew[5]]: this.state.IssueCategorycurrent,
        [this.state.quickfilterdatanew[6]]: this.state
          .IssueSponsoringMinistrycurrent,
        [this.state.quickfilterdatanew[7]]: this.state.ProjectStatuscurrent,
        [this.state.quickfilterdatanew[8]]: this.state.ProjectStagecurrent,
        [this.state.quickfilterdatanew[10]]: this.state.IssueZonecurrent
      });
    });
  };
  postFilterDatadelete_State = (value, filterName) => {
    //console.log(value);
    const targetObjectIndex = this.state.StateQuickFilters.findIndex(
      item => item.displayName === value.displayName
    );

    if (targetObjectIndex !== -1) {
      this.state.StateQuickFilters.splice(targetObjectIndex, 1);
    }
    let { issueListParams, filterArrayName } = this.state;
    let currentFilter = issueListParams[filterName];
    const filter = this.isFiltersAlreadyApplied(filterArrayName, value);

    this.setState({
      loadedIssuesListBy: {}
    });

    // to keep issueListParams seperate we are rendering filterArray name here
    if (filterName !== "projectIdFilter") {
      let newArr = [];
      if (!get(filter, "filter.displayName")) {
        newArr = [{ ...value, filterName }];
      } else {
        value.checked = false;
        filterArrayName.splice(get(filter, "index"), 1);
      }
      this.setState({
        filterArrayName: [...filterArrayName, ...newArr]
      });
    }
    const { key } = value || {};
    const [fromStr, toStr] = (key || "").split("-");
    const from = fromStr === "null" ? null : fromStr;
    const to = toStr === "null" ? null : toStr;
    const data = {
      from: from,
      to: to
    };
    switch (filterName) {
      // in this case value is object
      case "stages":
      case "category":
      case "subCategory":
      case "projectStatus":
      case "recipientState":
      case "recipientDistrict":
      case "recipientCenter":
      case "sponsoringState":
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "districtStateDept":
      case "recipientDistrictStateDept":
      case "assignedToDistrictStateDept":
      case "projectStage":
      case "recipientStateDepartment":
      case "issueDistStateDept":
      case "proponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "centerState":
      case "projectFlags":
      case "escalationLevel":
      case "issueZones":
        //console.log(currentFilter);
        currentFilter = currentFilter || [];
        let filter = currentFilter.find(val => val === value.key);
        !filter
          ? currentFilter.push(value.key)
          : (currentFilter = currentFilter.filter(val => val !== value.key));
        issueListParams = {
          ...issueListParams,
          [filterName]: currentFilter
        };
        break;

      // currentFilter = currentFilter || [];
      // const val = currentFilter.indexOf(+value.key) === -1;
      // val
      //   ? currentFilter.push(+value.key)
      //   : currentFilter.splice(currentFilter.indexOf(+value.key), 1);
      // issueListParams = {
      //   ...issueListParams,
      //   [filterName]: currentFilter,
      // };
      // break;

      // in this case value is string
      case "projectIdFilter":
        currentFilter = value || null;
        !currentFilter && delete issueListParams[filterName];
        issueListParams = value
          ? {
              ...issueListParams,
              sortBy: null,
              sortOrder: null,
              [filterName]: currentFilter
            }
          : { ...issueListParams, ...defaultListParams };
        break;

      case "mom":
        currentFilter = value.checked;
        !currentFilter && delete issueListParams[value.key];
        issueListParams = !currentFilter
          ? { ...issueListParams, ...defaultListParams }
          : { ...issueListParams, [value.key]: currentFilter };
        break;

      case "createdByMinistry":
        currentFilter = value.checked ? +value.key : null;
        !currentFilter && delete issueListParams[filterName];
        issueListParams = !currentFilter
          ? { ...issueListParams }
          : { ...issueListParams, [filterName]: currentFilter };
        break;

      // In this case value is boolean
      case "pmg":
      case "pragatiReview":
        currentFilter = value.checked;
        !currentFilter && delete issueListParams[filterName];
        issueListParams = !currentFilter
          ? { ...issueListParams, ...defaultListParams }
          : { ...issueListParams, [filterName]: currentFilter };
        break;

      case "projectGroupBy":
        currentFilter = value.checked;
        !currentFilter && delete issueListParams[filterName];
        issueListParams = !currentFilter
          ? { ...issueListParams, ...defaultListParams }
          : {
              ...issueListParams,
              [filterName]: currentFilter,
              sortOrder: null,
              sortBy: null
            };
        break;
      case "issueAgeing":
        const updatedArray = this.state.issueAgeing.filter(item => {
          return !(item.from === data.from && item.to === data.to);
        });
        this.setState({ issueAgeing: updatedArray });
        break;
      case "taskCompletionDate":
        const updatedArray1 = this.state.taskCompletionDate.filter(item => {
          return !(item.from === data.from && item.to === data.to);
        });
        this.setState({ taskCompletionDate: updatedArray1 });
        break;
      case "projectCost":
        const updatedArray2 = this.state.projectCost.filter(item => {
          return !(item.from === data.from && item.to === data.to);
        });
        this.setState({ projectCost: updatedArray2 });
        break;
      case "delayedProject":
        const updatedArray3 = this.state.taskCompletionDate.filter(item => {
          return !(item.from === data.from && item.to === data.to);
        });
        this.setState({ taskCompletionDate: updatedArray3 });
        break;
      case "costOverRun":
        const updatedArray4 = this.state.costOverRun.filter(item => {
          return !(item.from === data.from && item.to === data.to);
        });
        this.setState({ costOverRun: updatedArray4 });
        break;
      // currentFilter = currentFilter || [];
      // const { key } = value || {};
      // const from = key.split("-")[0];
      // const to = key.split("-")[1];
      // if (isValidArray(currentFilter)) {
      //   const keys = value.key.split("-");

      //   const index = currentFilter.indexOf(value => {
      //     const { key } = value;
      //     return key.from === from && key.to === to;
      //   });

      //   index
      //     ? currentFilter.splice(index, 1)
      //     : currentFilter.push({
      //         from: keys[0] === "null" ? null : keys[0],
      //         to: keys[1] === "null" ? null : keys[1]
      //       });
      // } else {
      //   currentFilter.push({
      //     from: from === "null" ? null : from,
      //     to: to === "null" ? null : to
      //   });
      // }
      // !currentFilter && delete issueListParams[filterName];
      // issueListParams = !currentFilter
      //   ? { ...issueListParams }
      //   : { ...issueListParams, [filterName]: currentFilter };
      // break;

      default:
        break;
    }

    return { ...issueListParams, offset: 0 };
  };
  postFilterDatadelete = (value, filterName) => {
    //console.log(value);
    const targetObjectIndex = this.state.bubbleFilters.findIndex(
      item => item.displayName === value.displayName
    );

    if (targetObjectIndex !== -1) {
      this.state.bubbleFilters.splice(targetObjectIndex, 1);
    }
    let { issueListParams, filterArrayName } = this.state;
    let currentFilter = issueListParams[filterName];
    const filter = this.isFiltersAlreadyApplied(filterArrayName, value);

    this.setState({
      loadedIssuesListBy: {}
    });

    // to keep issueListParams seperate we are rendering filterArray name here
    if (filterName !== "projectIdFilter") {
      let newArr = [];
      if (!get(filter, "filter.displayName")) {
        newArr = [{ ...value, filterName }];
      } else {
        value.checked = false;
        filterArrayName.splice(get(filter, "index"), 1);
      }
      this.setState({
        filterArrayName: [...filterArrayName, ...newArr]
      });
    }
    const { key } = value || {};
    const [fromStr, toStr] = (key || "").split("-");
    const from = fromStr === "null" ? null : fromStr;
    const to = toStr === "null" ? null : toStr;
    const data = {
      from: from,
      to: to
    };
    switch (filterName) {
      // in this case value is object
      case "stages":
      case "category":
      case "subCategory":
      case "projectStatus":
      case "recipientState":
      case "recipientDistrict":
      case "recipientCenter":
      case "sponsoringState":
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "districtStateDept":
      case "recipientDistrictStateDept":
      case "assignedToDistrictStateDept":
      case "projectStage":
      case "recipientStateDepartment":
      case "issueDistStateDept":
      case "proponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "centerState":
      case "projectFlags":
      case "escalationLevel":
      case "issueZones":
        //console.log(currentFilter);
        currentFilter = currentFilter || [];
        let filter = currentFilter.find(val => val === value.key);
        !filter
          ? currentFilter.push(value.key)
          : (currentFilter = currentFilter.filter(val => val !== value.key));
        issueListParams = {
          ...issueListParams,
          [filterName]: currentFilter
        };
        break;

      // currentFilter = currentFilter || [];
      // const val = currentFilter.indexOf(+value.key) === -1;
      // val
      //   ? currentFilter.push(+value.key)
      //   : currentFilter.splice(currentFilter.indexOf(+value.key), 1);
      // issueListParams = {
      //   ...issueListParams,
      //   [filterName]: currentFilter,
      // };
      // break;

      // in this case value is string
      case "projectIdFilter":
        currentFilter = value || null;
        !currentFilter && delete issueListParams[filterName];
        issueListParams = value
          ? {
              ...issueListParams,
              sortBy: null,
              sortOrder: null,
              [filterName]: currentFilter
            }
          : { ...issueListParams, ...defaultListParams };
        break;

      case "mom":
        currentFilter = value.checked;
        !currentFilter && delete issueListParams[value.key];
        issueListParams = !currentFilter
          ? { ...issueListParams, ...defaultListParams }
          : { ...issueListParams, [value.key]: currentFilter };
        break;

      case "createdByMinistry":
        currentFilter = value.checked ? +value.key : null;
        !currentFilter && delete issueListParams[filterName];
        issueListParams = !currentFilter
          ? { ...issueListParams }
          : { ...issueListParams, [filterName]: currentFilter };
        break;

      // In this case value is boolean
      case "pmg":
      case "pragatiReview":
        currentFilter = value.checked;
        !currentFilter && delete issueListParams[filterName];
        issueListParams = !currentFilter
          ? { ...issueListParams, ...defaultListParams }
          : { ...issueListParams, [filterName]: currentFilter };
        break;

      case "projectGroupBy":
        currentFilter = value.checked;
        !currentFilter && delete issueListParams[filterName];
        issueListParams = !currentFilter
          ? { ...issueListParams, ...defaultListParams }
          : {
              ...issueListParams,
              [filterName]: currentFilter,
              sortOrder: null,
              sortBy: null
            };
        break;
      case "issueAgeing":
        const updatedArray = this.state.issueAgeing.filter(item => {
          return !(item.from === data.from && item.to === data.to);
        });
        this.setState({ issueAgeing: updatedArray });
        break;
      case "taskCompletionDate":
        const updatedArray1 = this.state.taskCompletionDate.filter(item => {
          return !(item.from === data.from && item.to === data.to);
        });
        this.setState({ taskCompletionDate: updatedArray1 });
        break;
      case "projectCost":
        const updatedArray2 = this.state.projectCost.filter(item => {
          return !(item.from === data.from && item.to === data.to);
        });
        this.setState({ projectCost: updatedArray2 });
        break;
      case "delayedProject":
        const updatedArray3 = this.state.taskCompletionDate.filter(item => {
          return !(item.from === data.from && item.to === data.to);
        });
        this.setState({ taskCompletionDate: updatedArray3 });
        break;
      case "costOverRun":
        const updatedArray4 = this.state.costOverRun.filter(item => {
          return !(item.from === data.from && item.to === data.to);
        });
        this.setState({ costOverRun: updatedArray4 });
        break;
      // currentFilter = currentFilter || [];
      // const { key } = value || {};
      // const from = key.split("-")[0];
      // const to = key.split("-")[1];
      // if (isValidArray(currentFilter)) {
      //   const keys = value.key.split("-");

      //   const index = currentFilter.indexOf(value => {
      //     const { key } = value;
      //     return key.from === from && key.to === to;
      //   });

      //   index
      //     ? currentFilter.splice(index, 1)
      //     : currentFilter.push({
      //         from: keys[0] === "null" ? null : keys[0],
      //         to: keys[1] === "null" ? null : keys[1]
      //       });
      // } else {
      //   currentFilter.push({
      //     from: from === "null" ? null : from,
      //     to: to === "null" ? null : to
      //   });
      // }
      // !currentFilter && delete issueListParams[filterName];
      // issueListParams = !currentFilter
      //   ? { ...issueListParams }
      //   : { ...issueListParams, [filterName]: currentFilter };
      // break;

      default:
        break;
    }

    return { ...issueListParams, offset: 0 };
  };
  clearAll = () => {
    this.setState(
      {
        issueListParams: { ...defaultListParams },
        filterArrayName: [],
        bubbleFilters: [],
        StateQuickFilters: []
      },
      () => {
        this.getIssueListData({
          groupCategory: this.getGroupCategory()
        });
      }
    );
    localStorage.setItem("ClearAll", JSON.stringify(true));
  };

  handleCheckbox = (filter, filterName) => {
    const filterData = this.postFilterData(filter, filterName);
    this.setState(
      {
        loadedIssuesListBy: {}
      },
      () => {
        this.getIssueListData({ ...filterData, offset: 0 });
      }
    );
  };
  handleCheckbox1 = (filter, filterName) => {
    if (filter.hasOwnProperty("filterName")) {
      const entries = Object.entries(filter);
      const lastEntry = entries.pop();
      delete filter[lastEntry[0]];
      //console.log(value)
    }
    const filterData = this.postFilterDatadelete(filter, filterName);
    this.setState(
      {
        loadedIssuesListBy: {}
      },
      () => {
        this.getIssueListData({ ...filterData, offset: 0 });
      }
    );
  };
  handleStateCheckbox = (filter, filterName) => {
    if (filter.hasOwnProperty("filterName")) {
      const entries = Object.entries(filter);
      const lastEntry = entries.pop();
      delete filter[lastEntry[0]];
      //console.log(value)
    }
    const filterData = this.postFilterDatadelete_State(filter, filterName);
    this.setState(
      {
        loadedIssuesListBy: {}
      },
      () => {
        this.getIssueListData({ ...filterData, offset: 0 });
      }
    );
  };

  onLoadMore = async () => {
    const { isAllDataLoaded } = this.state;
    if (isAllDataLoaded) {
      return;
    }
    this.setState(
      {
        isAllDataLoaded: true
      },
      () => {
        const {
          issueListParams: { offset }
        } = this.state;
        this.getIssueListData({ offset: offset + 1 });
      }
    );
  };

  onProjectAwardedByChangeforIssue = e => {
    //console.log("In onProjectAwardedByChange");
    this.setState(
      {
        projectAwardedByForIssue: e.target.checked,
        issueListParams: { ...defaultListParams },
        filterArrayName: [],
        bubbleFilters: []
      },
      () => {
        this.getIssueListData({
          ...{
            groupCategory: this.getGroupCategory()
          }
        });
      }
    );
  };

  getGroupCategory = () => {
    return this.state.projectAwardedByForIssue
      ? PROJECT_AWARDED_BY.STATE
      : PROJECT_AWARDED_BY.CENTRAL;
  };

  closeIssueModel = () => {
    const { closeModal, closeProjectModal } = this.props;
    closeModal();
    closeProjectModal();
  };

  render() {
    const { show, closeModal, selectedProjects } = this.props;

    const {
      loadedIssuesListBy,
      issueListApiStatus,
      isLoadingOnScroll,
      selectAll,
      selectedFilter,
      clearAll,
      issueListParams,
      filterArrayName,
      projectAwardedByForIssue,
      addInAgendaDisable
    } = this.state;
    //
    //console.log(addInAgendaDisable);
    const filters = loadedIssuesListBy[0]
      ? loadedIssuesListBy[0]["filters"]
      : {};

    const { total } = loadedIssuesListBy[0] || {};

    // count
    let count = 0;

    // make single array for issues
    // its for issues are now loading on scroll
    let issuesList = [];
    Object.keys(loadedIssuesListBy).forEach(key => {
      issuesList = [...issuesList, ...loadedIssuesListBy[key]["listDTO"]];
    });

    // make all issues active if select all is active
    isValidArray(issuesList) &&
      issuesList.forEach(issue => {
        selectAll && (issue.isSelected = true);
        issue.isSelected && count++;
      });

    return (
      <React.Fragment>
        <LoaderPage
          loading={
            isLoadingOnScroll === STATUS.LOADING ||
            issueListApiStatus === STATUS.LOADING
          }
        />
        <Modal
          show={show}
          dialogClassName="modal-select-issue agenda-select-issue pragati-select-issue"
          onHide={closeModal}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Select Issue(s){" "}
              {(total && <span className="totalCount">({total})</span>) || null}
            </Modal.Title>
          </Modal.Header>
          <LoadListOnScroll
            //callApiOnScroll={this.loadPageOnScroll}
            offset={issueListParams.offset}
          >
            <Modal.Body className="scroll">
              <div
                className="issue-list-content agenda-issue-list-content"
                ref={elem => {
                  this.modalWrapper = elem;
                }}
              >
                {/*<IssueFilters*/}
                {/*filterArray={filterArray}*/}
                {/*getFilterIssueList={this.getFilterIssueList}*/}
                {/*agenda={true}*/}
                {/*/>*/}
                <div className="issue-list-filter-wrapper agenda-field">
                  <Form>
                    <ToggleBtn
                      checked={projectAwardedByForIssue}
                      callback={this.onProjectAwardedByChangeforIssue}
                      id="issueToggle"
                    />
                    <div className="issue-list-filters">
                      <div className="filter-header">
                        <div className="filter-title">
                          <Image src={IconFilter} alt="Filter Icon" />
                          <span>Filters</span>
                        </div>
                        {console.log(this.state.projectAwardedByForIssue)}
                        {this.state.projectAwardedByForIssue ? (
                          <>
                            {/* {isValidArray(filterArrayName) ? (
                              <div
                                className="clear-filter"
                                onClick={this.clearAll}
                              >
                                Clear All
                              </div>
                            ) : null} */}
                          </>
                        ) : (
                          <>
                            <PragatiIssueQuickFilter
                              filtersValue={issueListParams}
                              filterData={filters}
                              staticFilterData={this.state.staticfilterdata}
                              onFilterChange={this.handleFilterChange}
                              checkedData={this.state.bubbleFilters}
                              onChange1={this.postFilterData1}
                              onChange2={this.postFilterData2}
                              onChange3={this.postFilterData3}
                              onChange4={this.postFilterData4}
                              onChange5={this.postFilterData5}
                              onChange6={this.postFilterData6}
                              onChange7={this.postFilterData7}
                              onChange8={this.postFilterData8}
                              onChange9={this.postFilterData9}
                              onChange10={this.postFilterData10}
                              AgendaIssueStage={
                                this.state.agendaissuestagesdata
                              }
                            />
                          </>
                        )}
                        {this.state.projectAwardedByForIssue ? (
                          <AgendaStateIssueQF
                            filtersValue={issueListParams}
                            filterData={filters}
                            staticFilterData={
                              this.state.staticfilterdata_for_state
                            }
                            onFilterChange={this.handleFilterChange}
                            checkedData={this.state.bubbleFilters}
                            onChange1={this.postFilterData1_State}
                            onChange2={this.postFilterData2_State}
                            onChange3={this.postFilterData3_State}
                            onChange4={this.postFilterData4_State}
                            onChange5={this.postFilterData5_State}
                            onChange6={this.postFilterData6_State}
                            onChange7={this.postFilterData7_State}
                            onChange8={this.postFilterData8_State}
                            AgendaIssueStage={this.state.agendaissuestagesdata}
                          />
                        ) : null}
                        {/** {isValidArray(filterArrayName) ? (
                          <div className="clear-filter" onClick={this.clearAll}>
                            Clear All
                          </div>
                        ) : null} */}
                      </div>
                      {issueListApiStatus === STATUS.LOADING ? (
                        <LoaderTemplate
                          parentClass={"filter-loader-project-list"}
                          children={<FilterLoader />}
                          height={300}
                          width={400}
                        />
                      ) : (
                        <FilterComponent
                          //clearAll={clearAll}
                          selectedFilters={selectedFilter}
                          filterData={filters}
                          filtersValue={issueListParams}
                          onChange={this.handleCheckbox}
                          projectCategory={this.getGroupCategory()}
                        />
                      )}
                    </div>
                  </Form>
                </div>
                <div className="issue-list-multiple">
                  <div className="select-all">
                    <Form.Group>
                      <Form.Check
                        className={`form-checkbox ${
                          selectAll ? "checked" : ""
                        }`}
                      >
                        <Form.Check.Input
                          type="checkbox"
                          name="select-issue"
                          value={selectAll}
                        />
                        <Form.Check.Label onClick={this.toggleSelectAll} />
                        <span>Select All</span>
                      </Form.Check>
                    </Form.Group>
                  </div>
                  <SelectIssueSearchSort
                    params={issueListParams}
                    sortBy={sortByArr}
                    //defaultDates={dateFilter}
                    callApiOnSuccess={params => {
                      this.getIssueListData({ ...params, offset: 0 });
                    }}
                  />
                  {this.state.projectAwardedByForIssue ? (
                    <div className="applied-filter-list">
                      {this.state.bubbleFilters.length == 0 ? null : (
                        <>
                          {this.state.bubbleFilters.map((element, index) => (
                            <div className="applied-filter" key={index}>
                              {element.displayName}
                              <span
                                className="close"
                                onClick={e => {
                                  this.handleCheckbox1(
                                    element,
                                    element.filterName
                                  );
                                }}
                              >
                                X
                              </span>
                            </div>
                          ))}
                        </>
                      )}
                      {this.state.bubbleFilters.length > 1 ? (
                        <div
                          className="clear-filter-new"
                          onClick={this.clearAll}
                        >
                          Clear All
                        </div>
                      ) : null}
                    </div>
                  ) : (
                    <>
                      <div className="applied-filter-list">
                        {this.state.bubbleFilters.length == 0 ? null : (
                          <>
                            {this.state.bubbleFilters.map((element, index) => (
                              <div className="applied-filter" key={index}>
                                {element.displayName}
                                <span
                                  className="close"
                                  onClick={e => {
                                    this.handleCheckbox1(
                                      element,
                                      element.filterName
                                    );
                                  }}
                                >
                                  X
                                </span>
                              </div>
                            ))}
                          </>
                        )}
                        {this.state.bubbleFilters.length > 1 ? (
                          <div
                            className="clear-filter-new"
                            onClick={this.clearAll}
                          >
                            Clear All
                          </div>
                        ) : null}
                      </div>
                    </>
                  )}

                  <div className="select-issue-list-wrapper">
                    <SelectIssueWithLoader
                      issues={issuesList}
                      // issues={loadedIssuesListBy[filterArray.offset]}
                      isLoading={issueListApiStatus}
                      selectionHandler={this.selectionHandler}
                      IssueSelected="checkbox"
                    />
                    {total !== issuesList.length ? (
                      <Button
                        className="load-more-issue-btn"
                        onClick={this.onLoadMore}
                      >
                        Load More
                      </Button>
                    ) : null}
                  </div>
                </div>
              </div>
            </Modal.Body>
          </LoadListOnScroll>

          <Modal.Footer className="sticky-footer">
            <div className="selected-issues">
              Selected Projects: <span>{selectedProjects.length || 0}</span>{" "}
              <span className="verticle-bar"> | </span>
              Selected Issues: <span>{count || 0}</span>
            </div>
            <Button
              className="btn-orange-invert no-padding issue-back-btn"
              onClick={closeModal}
            >
              <span className="issue-back-icon" /> Back
            </Button>
            {addInAgendaDisable ? (
              <TooltipCustom text="Select new Projects or Issues to add">
                <Button
                  className="btn-orange no-padding"
                  disabled={addInAgendaDisable}
                  onClick={this.submitHandler}
                >
                  Add in Agenda
                </Button>
              </TooltipCustom>
            ) : (
              <Button
                className="btn-orange no-padding"
                disabled={addInAgendaDisable}
                onClick={this.submitHandler}
              >
                Add in Agenda
              </Button>
            )}

            <Button
              className="btn-orange-invert no-padding btn-cancel"
              onClick={this.closeIssueModel}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    issueList: state.commonReducer.issueList,
    issueListApiStatus: state.commonReducer.issueListStatus
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getIssueList: getIssueList,
      clearIssueListDispatch: clearIssueList,
      getIssueListForAgendaSelect
    },
    dispatch
  );
}

export default withRouter(
  PermissionHoc(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(SelectIssue)
  )
);
